import React from 'react'
import { KLAP, WEBPAY } from '../../constants/payment'
import { usePayment } from '../../hook/payment/usePayment/usePayment'
import PropTypes from 'prop-types'
import { CardForm, Modal } from '@pinflag/pinflag-ui-kit'
import { useKlap } from '../../hook/payment/gateways/useKlap'
import { usePaymentHandlers } from '../../hook/payment/usePaymentHandlers'

const GatewayForm = ({ gateway, scrapperClient }) => {
  const {
    isSavingCard,
    setIsSavingCard,
    selectedPaymentOption,
    isPaying,
    showGatewayForm,
    paymentOrderResult,
    cardCvv,
    cardNumber,
    cardExpiryDate,
    installments,
    setPaymentState,
    isLoadingGatewayForm
  } = usePayment()

  const { handlePaymentApproval, handlePaymentRejected } = useKlap()

  const { handleConfirmPayment, canUserPayWithGateway } = usePaymentHandlers({ scrapperClient })

  const isPayingWithCreditCard = selectedPaymentOption === 'credit'

  const klapFormArgs = {
    id: 'checkout-klap',
    'data-klap-order-id': paymentOrderResult?.orderId,
    'data-klap-fn-success': 'paymentApproval',
    'data-klap-fn-error': 'paymentReject'
  }

  const updateFormState = (key, value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      [key]: value
    }))
  }

  const handleClose = () => {
    setPaymentState((prevState) => ({
      ...prevState,
      showGatewayForm: false,
      hasConfirmedPaymentMethod: false
    }))
  }

  // This function is called by the Klap SDK when the payment is approved
  // ❗️The name must be the same as the declared one in the Klap Form
  window.paymentApproval = () => {
    return handlePaymentApproval()
  }

  // This function is called by the Klap SDK when the payment is rejected
  // ❗️The name must be the same as the declared one in the Klap Form
  window.paymentReject = (error) => {
    return handlePaymentRejected(error)
  }

  if (gateway !== KLAP && gateway !== WEBPAY) {
    return null
  }

  return (
    <Modal
    icon="credit-card"
    isOpenModal={showGatewayForm}
    modalTitle="Pago con tarjeta"
    modalText="Ingresa los datos de tu tarjeta"
    handleClose={handleClose}
    loading={isPaying}
  >
    <CardForm
      isLoading={isLoadingGatewayForm}
      formArgs={gateway === KLAP ? klapFormArgs : {}}
      disableInputs={isPaying}
      cardNumber={cardNumber}
      isCreditCard={isPayingWithCreditCard}
      updateCardNumber={(value) => updateFormState('cardNumber', value)}
      cardExpiryDate={cardExpiryDate}
      updateCardExpiryDate={(value) => updateFormState('cardExpiryDate', value)}
      cardCvv={cardCvv}
      updateCardCvv={(value) => updateFormState('cardCvv', value)}
      installments={installments}
      updateInstallments={(value) => updateFormState('installments', value)}
      isSavingCard={isSavingCard}
      updateIsSavingCard={() => setIsSavingCard(!isSavingCard)}
      showSaveCardCheckbox={gateway === KLAP}
      handleCancel={handleClose}
      handlePayment={handleConfirmPayment}
      canUserGoBack={!isPaying}
      canUserPay={canUserPayWithGateway() && !isPaying}
      isPaying={isPaying}
    />
  </Modal>
  )
}

GatewayForm.propTypes = {
  gateway: PropTypes.string,
  scrapperClient: PropTypes.string
}

export default GatewayForm
